import React from 'react';
import { slogans, seoKeywords, heroContent } from '../data/content';

const MarketingStrategy = () => {
  return (
    <div className="pt-24 pb-20 bg-ms-light min-h-screen">
      <div className="max-w-5xl mx-auto px-4">
        <div className="bg-white p-12 rounded-[3rem] shadow-2xl border border-ms-blue/5">
          <h1 className="text-4xl font-black text-ms-dark mb-8 border-b-4 border-ms-blue pb-4 uppercase tracking-tighter">Marketing & SEO Strategie</h1>
          
          <div className="grid md:grid-cols-3 gap-8 mb-12">
            <div className="bg-ms-blue p-6 rounded-3xl text-white">
              <h3 className="font-black uppercase tracking-widest text-xs mb-2 text-ms-solar">Primary Brand</h3>
              <p className="text-2xl font-black">#1FB6FF</p>
            </div>
            <div className="bg-ms-solar p-6 rounded-3xl text-white">
              <h3 className="font-black uppercase tracking-widest text-xs mb-2 text-ms-blue">Solar Tech</h3>
              <p className="text-2xl font-black">#0A4FA3</p>
            </div>
            <div className="bg-ms-red p-6 rounded-3xl text-white">
              <h3 className="font-black uppercase tracking-widest text-xs mb-2 text-red-200">CTA Power</h3>
              <p className="text-2xl font-black">#E10600</p>
            </div>
          </div>

          <section className="mb-12">
            <h2 className="text-2xl font-black text-ms-dark mb-6 uppercase tracking-tight">1. Slogans (Konversion-orientiert)</h2>
            <div className="bg-ms-light p-8 rounded-3xl h-64 overflow-y-auto space-y-4">
              {slogans.map((slogan, i) => (
                <div key={i} className="flex items-center font-bold text-ms-dark border-b border-ms-blue/10 pb-2 italic">
                   <div className="w-2 h-2 bg-ms-red rounded-full mr-4"></div>
                   {slogan}
                </div>
              ))}
            </div>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-black text-ms-dark mb-6 uppercase tracking-tight">2. SEO Keyword Cluster</h2>
            <div className="grid md:grid-cols-3 gap-8">
              <div className="space-y-4">
                <h3 className="font-black text-ms-blue uppercase tracking-widest text-xs">Short-Tail</h3>
                <div className="flex flex-wrap gap-2">
                   {seoKeywords.short.map((k, i) => <span key={i} className="bg-ms-light px-3 py-1 rounded-full text-xs font-bold text-ms-solar">{k}</span>)}
                </div>
              </div>
              <div className="space-y-4">
                <h3 className="font-black text-ms-blue uppercase tracking-widest text-xs">Long-Tail</h3>
                <div className="flex flex-wrap gap-2">
                   {seoKeywords.longtail.map((k, i) => <span key={i} className="bg-ms-light px-3 py-1 rounded-full text-xs font-bold text-ms-solar">{k}</span>)}
                </div>
              </div>
              <div className="space-y-4">
                <h3 className="font-black text-ms-blue uppercase tracking-widest text-xs">Local (NRW)</h3>
                <div className="flex flex-wrap gap-2">
                   {seoKeywords.local.map((k, i) => <span key={i} className="bg-ms-light px-3 py-1 rounded-full text-xs font-bold text-ms-solar">{k}</span>)}
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default MarketingStrategy;